<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div class="title">编辑课程</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">

        <el-form :model="editForm" :rules="rules" ref="editForm">

          <el-row>
            <el-col :span="6" class="item">
              <el-form-item label="视频" required prop="videoUrl">
                <el-upload class="upload-demo"
                           :action="uploadUrl"
                           list-type="picture-card"
                           :data='uploadData'
                           :show-file-list="false"
                           :on-success="handleImgSuccess"
                           style="width:100%;margin-top:40px">

                  <video v-if="editForm.videoUrl" :src="editForm.videoUrl" style="width: 100%;height: 100%;border-radius: 6px;"/>
                  <!--                  <img v-if="addForm.icon" :src="addForm.icon" fit='cover' style="width: 100%;height: 100%;border-radius: 6px;">-->
                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>

                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="18" class="item">
              <el-row>
                <el-col :span="24" class="item">
                  <el-form-item label="名称" required prop="title">
                    <el-input v-model="editForm.title" placeholder="请输入名称"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24" class="item">
                  <el-form-item label="排序" required prop="sort">
                    <el-input v-model.number="editForm.sort" placeholder="请输入排序"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
          </el-row>



        </el-form>

      </div>
      <div class="modal-footer">
        <el-button @click="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click="confirm('editForm')">保存</el-button>
      </div>
    </div>
  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";


export default {
  name: 'Add',
  props:['attributeList'],
  data() {
    return {
      loading: false,

      uploadUrl:this.$shopUrl+'Upload/Video',
      uploadData:{
        staffCode:getStaffCode(),
        timeStr:timeStr,
        sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey)
      },

      editForm:{
        timeStr:timeStr,
        staffCode:getStaffCode(),
        sign:'',

        title:'',
        videoUrl:'',
        sort:'',
        trainCourseCode:'',
      },


      rules:{
        title:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        sort:[
          { required: true, message: '请输入排序', trigger: 'blur' },
        ],
        videoUrl:[
          { required: true, message: '请上传视频', trigger: 'blur' },
        ],

      },


    }
  },

  methods: {
    init(row){
      this.$refs.editForm.resetFields();

      this.editForm.trainCourseCode = row.trainCourseCode;
      this.editForm.title = row.title;
      this.editForm.videoUrl = this.$imgUrl+row.videoUrl;
      this.editForm.sort = row.sort;

    },


    closeSelf() {
      this.$emit("closeCourseEdit");
    },


    handleImgSuccess(res, file) {
      console.log(file)
      console.log(res)

      if(res.error == 0){
        this.editForm.videoUrl = this.$imgUrl+res.data.path;
      }

    },


    confirm(addForm){
      this.$refs[addForm].validate((valid) => {
        if(valid){
          if(!this.editForm.videoUrl){
            this.$message({type: 'warning', message: '请上传视频'});
            return;
          }
          this.addSubmit();
        }else {
          console.log('error submit!!');
          return false;
        }
      })

    },

    addSubmit(){

      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.editForm.videoUrl=this.editForm.videoUrl.replace(this.$imgUrl,'')

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"TrainCourse/Edit",
        data: this.editForm
      }).then((response) => {
        this.loading = false;
        if (response.data.error == 0) {
          this.$emit("closeCourseEdit");
          this.$emit("getList");
        }else if(response.data.error == 1){
          this.$message.error(response.data.message)
        }
      })

    },


  }
}


</script>

<style lang="scss" scoped>

</style>
